import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ArgusApiService {

  constructor(private httpClient: HttpClient) { }

  getBrands() {
    return this.httpClient.get("https://analog-argus-storage.herokuapp.com/public/api/brands");
  }

  getBrand(id: number) {
    return this.httpClient.get("https://analog-argus-storage.herokuapp.com/public/api/brands/" + id);
  }

  searchModel(body: { searched_model: string }) {
    return this.httpClient.post("https://aa-webscraping.herokuapp.com/search", body)
  }
}
